<script lang="ts">
  import { user } from './lib/stores';
  import Layout from './components/Layout.svelte';

  let route = $state(window.location.hash.slice(1) || '/');

  window.addEventListener('hashchange', () => {
    route = window.location.hash.slice(1) || '/';
  });
</script>

<Layout {route} />
